module.exports = __webpack_public_path__ + "img/ele-sign.5d6868c0.svg";